import { render, staticRenderFns } from "./RemolcadorDocumento.vue?vue&type=template&id=24b04466"
import script from "./RemolcadorDocumento.vue?vue&type=script&lang=js"
export * from "./RemolcadorDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports